import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Pipe({ name: 'durationMinutes' })
export class DurationMinutesPipe implements PipeTransform {

    constructor(private translateService: TranslateService) {

    }

    transform(value: number ): string {

        if(!value){
            return "0 " +  this.translateService.instant('global.minutesDurationUnit');
        }

        const days = Math.floor(value/(24*60));

        value = value - (days * 24 * 60);
        
        const hours = Math.floor(value/60);

        value = value - (hours * 60);

        const minutes = value;

        let result = '';
        
        if(days > 0){
            result += days + ' ' + this.translateService.instant('global.daysDurationUnit');
        }

        if(hours > 0){
            result += ' ' + hours + ' ' + this.translateService.instant('global.hoursDurationUnit');
        }

        if(minutes > 0){
            result += ' ' + minutes + ' ' + this.translateService.instant('global.minutesDurationUnit');
        }

        return result;
    }
}